export const REQUEST_DATE_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_DATE_FORMAT = 'DD-MMM YYYY';
export const DEFAULT_DATE_TIME_A_FORMAT = 'DD-MMM YYYY hh:mm A';
export const DEFAULT_SYSTEM_USER = 'System';

export const DATE_MINIMUM = '1990-01-01';

export const GIVE_FEEDBACK_URL = 'https://28yhv5ik85n.typeform.com/to/VnoBJXwB';